module.exports = __webpack_public_path__ + "img/1792.60a978bf.gif";